import { useCanAccessResources } from "react-admin";
import { Navigate } from "react-router-dom";

import { hasStaffNavigationAccess, type PortalResource } from "../auth/access";
import {
  CUSTOMER_SERVICE_ORGANIZATIONS_RESOURCE,
  ResourceName,
  SALESFORCE_DASHBOARD_ROUTE,
} from "../constants/resources";
import { CRM_ROUTE } from "../lib/crm";
import { CUSTOMER_SERVICE_ORGANIZATIONS_ROUTE } from "../lib/customerServiceOrganizationRoutes";
import { MARKETING_ROUTE } from "../lib/marketing";
import { HomeDashboard } from "./HomeDashboard";

// A user starts on the first of these pages their access allows.
const HOME_RESOURCES: PortalResource[] = [
  ResourceName.Location,
  ResourceName.SalesforceDashboard,
  ResourceName.Marketing,
  ResourceName.Crm,
  CUSTOMER_SERVICE_ORGANIZATIONS_RESOURCE,
  ResourceName.Analytics,
  ResourceName.Learning,
];

export const PortalHome = () => {
  const { canAccess, isPending, error } = useCanAccessResources({ action: "list", resources: HOME_RESOURCES });
  if (isPending) return null;
  if (error) return <Navigate to="/authentication-error" replace />;
  // Staff, admin@m4c.app among them, start on a staff page: their menu has no manager pages.
  if (canAccess?.[ResourceName.Location] && !hasStaffNavigationAccess(canAccess)) return <HomeDashboard />;
  if (canAccess?.[ResourceName.SalesforceDashboard]) return <Navigate to={SALESFORCE_DASHBOARD_ROUTE} replace />;
  if (canAccess?.[ResourceName.Marketing]) return <Navigate to={MARKETING_ROUTE} replace />;
  if (canAccess?.[ResourceName.Crm]) return <Navigate to={CRM_ROUTE} replace />;
  if (canAccess?.[CUSTOMER_SERVICE_ORGANIZATIONS_RESOURCE]) {
    return <Navigate to={CUSTOMER_SERVICE_ORGANIZATIONS_ROUTE} replace />;
  }
  if (canAccess?.[ResourceName.Analytics]) return <Navigate to="/analytics/trends" replace />;
  if (canAccess?.[ResourceName.Learning]) return <Navigate to="/learning" replace />;
  return <Navigate to="/access-denied" replace />;
};
